import React from "react";
import { YesNoPanel } from "../../../components/wizards/YesNoPanel";
import { WizardContext } from "../WizardContext";

export const AnyFollowupScreen = () => (
  <WizardContext.Consumer>
    {({ dispatch }) => (
      <>
        <YesNoPanel
          question="Is any additional followup required?"
          yesAction={() => {
            dispatch({
              type: "setAnswer",
              key: "additionalFollowup",
              value: true,
              doTransition: true,
            });
          }}
          noAction={() => {
            dispatch({
              type: "setAnswer",
              key: "additionalFollowup",
              value: false,
              doTransition: true,
            });
          }}
        />
      </>
    )}
  </WizardContext.Consumer>
);
